// unit-c-frontend/src/components/SocialMedia/AudioList.jsx
import React from 'react';
import { FiMusic, FiTrash2 } from 'react-icons/fi';

const formatSize = (bytes) => {
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const AudioList = ({ items, onDelete }) => {
    if (!items.length) {
        return <p className="mp-empty">No audio files yet. Upload some!</p>;
    }

    return (
        <div className="mp-audio-list">
            {items.map(item => (
                <div key={item.id} className="mp-audio-card">
                    <div className="mp-audio-thumb">
                        <FiMusic size={20} />
                    </div>
                    <div className="mp-audio-info">
                        <div className="mp-audio-name">{item.original_filename}</div>
                        <div className="mp-audio-size">{formatSize(item.file_size)}</div>
                    </div>
                    <button
                        className="mp-audio-delete"
                        onClick={() => onDelete(item.id)}
                        title="Delete"
                    >
                        <FiTrash2 size={16} />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default AudioList;
